import { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
// Canonical site URL for JSON-LD. Uses the current origin at runtime so it
// automatically matches wherever the site is served from (production, preview,
// custom domain), instead of being hardcoded.
const SITE_URL = typeof window !== "undefined"
  ? window.location.origin
  : "https://barcolac.com.au";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_the-bar-live/artifacts/a25cx4t7_TheBar_Colac_COL_COASTER_LOGO.png";
const SCRIPT_ID = "events-jsonld";

/**
 * Injects schema.org Event JSON-LD for upcoming events into <head>.
 * Uses real start/end datetimes + performer from the backend.
 */
export default function SeoEventsSchema() {
  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/events`)
      .then((r) => {
        if (cancelled) return;
        const items = (r.data || [])
          .filter((ev) => ev.start_date_time)
          .map((ev) => {
            const performerName = (ev.performer && ev.performer.trim()) || ev.title;
            const performerType =
              ["MusicGroup", "Person"].includes(ev.performer_type)
                ? ev.performer_type
                : "PerformingGroup";

            return {
              "@context": "https://schema.org",
              "@type": "Event",
              "name": ev.title,
              "startDate": ev.start_date_time,
              "endDate": ev.end_date_time || undefined,
              "eventStatus": "https://schema.org/EventScheduled",
              "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
              "description": ev.description || ev.title,
              "url": ev.fbUrl,
              "image": [LOGO_URL],
              "location": {
                "@type": "Place",
                "name": "The Bar Colac",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "27 Murray Street",
                  "addressLocality": "Colac",
                  "addressRegion": "VIC",
                  "postalCode": "3250",
                  "addressCountry": "AU",
                },
              },
              "performer": {
                "@type": performerType,
                "name": performerName,
              },
              "organizer": {
                "@type": "Organization",
                "name": "The Bar Colac",
                "url": SITE_URL,
              },
              "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "AUD",
                "availability": "https://schema.org/InStock",
                "url": ev.fbUrl,
                "validFrom": ev.start_date_time,
              },
            };
          });

        // Remove any previous injection (handles dev hot-reload)
        const existing = document.getElementById(SCRIPT_ID);
        if (existing) existing.remove();

        if (items.length === 0) return;

        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = SCRIPT_ID;
        // Strip undefined keys so Google doesn't see "endDate": null etc.
        script.text = JSON.stringify(items, (k, v) => (v === undefined ? undefined : v));
        document.head.appendChild(script);
      })
      .catch(() => {
        /* silent — SEO is best-effort, no UI impact */
      });

    return () => {
      cancelled = true;
      const tag = document.getElementById(SCRIPT_ID);
      if (tag) tag.remove();
    };
  }, []);

  return null;
}
